const ENTITY_STATUS_TABLE_READY = "entity-status-table-ready"
const SEARCH_TEXT_STATE = "entity-status-table-search-text-state"
const ROWS_PER_PAGE_STATE = "entity-status-table-rows-per-page-state"
const PAGINATION_STATE = "entity-status-table-pagination-state"

const ENTITY_STATUS_ID_FOR_ACTION = "entity-status-table-brand-id-for-action"


const ADDEDIT_ENTITY_STATUS_READY = "entity-status-table-addedit-entity-status-ready"

const initialState = {
    isEntityStatusTableReady: true,
    isAddEditEntityStatusReady: true,
    entityStatus: {},

    
    entityStatusSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ENTITY_STATUS_TABLE_READY:
            return Object.assign({}, state, { isEntityStatusTableReady: action.payload })

        case ADDEDIT_ENTITY_STATUS_READY:
            return Object.assign({}, state, { isAddEditEntityStatusReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ENTITY_STATUS_ID_FOR_ACTION:
            return Object.assign({}, state, {entityStatusSelectedId:action.payload})

        default:
        return state
    
    }

}

export function entityStatusTableReady(data) {
    return {
        type: ENTITY_STATUS_TABLE_READY,
        payload: data
    }
}

export function addEditEntityStatusReady(data) {
    return {
        type: ADDEDIT_ENTITY_STATUS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function entityStatusIdForAction(entityStatusId){
    return{
        type:ENTITY_STATUS_ID_FOR_ACTION,
        payload:entityStatusId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Entity Status/redux/entity_status.js